import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Instagram, Lock } from "lucide-react";
import { useSettings } from "@/lib/settings";

export default function Footer() {
  const { settings } = useSettings();
  return (
    <footer id="contatti-footer" className="bg-brand text-white">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 py-16 sm:px-8 md:grid-cols-3">
        <div>
          <div className="inline-block bg-white p-3">
            <img src="/logo.png" alt="Lattanzi Costruzioni" className="h-16 w-auto" />
          </div>
          <p className="mt-5 max-w-xs text-sm leading-relaxed text-blue-100">
            Impresa edile a conduzione familiare. Mezzo secolo di serietà, professionalità e qualità abitativa.
          </p>
        </div>
        <div data-testid="footer-contacts" className="space-y-3 text-sm text-blue-50">
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-white/70">Contatti</p>
          <p className="flex items-center gap-3"><Phone className="h-4 w-4 text-white/70" /> Tel. e Fax {settings.phone}</p>
          <p className="flex items-center gap-3"><Mail className="h-4 w-4 text-white/70" /> {settings.email}</p>
          <p className="flex items-center gap-3"><MapPin className="h-4 w-4 text-white/70" /> {settings.address}</p>
          {settings.instagram && (
            <a
              href={settings.instagram}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram-link"
              className="flex items-center gap-3 transition-colors duration-300 hover:text-white"
            >
              <Instagram className="h-4 w-4 text-white/70" /> Instagram — @lattanzicostruzioni
            </a>
          )}
        </div>
        <div className="space-y-3 text-sm text-blue-50">
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-white/70">Dati Aziendali</p>
          <p>P.I. e C.F. {settings.piva}</p>
          <p className="text-blue-100">{settings.mobiles}</p>
        </div>
      </div>
      <div className="border-t border-white/15 py-5">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-5 font-mono text-[10px] uppercase tracking-[0.3em] text-white/60 sm:px-8">
          <span>Lattanzi Costruzioni — La qualità a casa tua</span>
          <Link
            to="/area-riservata"
            data-testid="footer-link-admin"
            className="flex items-center gap-1.5 transition-colors duration-300 hover:text-white"
          >
            <Lock className="h-3 w-3" /> Area Riservata
          </Link>
        </div>
      </div>
    </footer>
  );
}
